import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Col, Select, Button } from 'antd';
import CircleDown from 'react-icons/lib/fa/chevron-circle-down';

import './index.scss';

import { PERMISSIONS } from '../../../../../../data/config/constants';
import { showMessage } from '../../../../../../data/config/utils';
import { createUtterance } from '../../../../../../data/redux/nlp_details/actions';

import ShowMessage from '../../../../../../components/showmessage';
import TextEditor from '../../../texteditor';
import EntityEditor from '../../../entityeditor';

const Option = Select.Option;

class Insight extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      intent_extended: false,
      selected_entity: null
    };
  }

  handleSelectedEntityRange = (range) => {
    const { active_popup_message } = this.props;
    if (range && range.endIndex >= range.startIndex) {
      const entity = active_popup_message.payload.text.substr(range.startIndex, range.endIndex - range.startIndex + 1);
      this.setState({
        selected_entity: {
          ...this.state.selected_entity,
          startIndex: range.startIndex,
          endIndex: range.endIndex,
          entity,
        }
      });
    }
  };

  createNewEntity = () => {
    this.props.addEntity(this.state.selected_entity);
    this.setState({
      intent_extended: true,
      selected_entity: null
    });
  };

  handleSave = () => {
    const { isActionPermitted, active_popup_message, actions, closeModal } = this.props;
    if (isActionPermitted && isActionPermitted(PERMISSIONS.ACTIONS.UTTERANCE, PERMISSIONS.ACTION_TYPES.CREATE) && isActionPermitted(PERMISSIONS.ACTIONS.UTTERANCE, PERMISSIONS.ACTION_TYPES.UPDATE)) {
      const payload = {
        psid: this.props.psid ? this.props.psid : null,
        chatlogId: active_popup_message.chatlogId,
        text: active_popup_message.payload.text,
        NLPSnapshot: { ...active_popup_message.NLPSnapshot }
      };
      actions.createUtterance(payload, closeModal);
    } else
      showMessage('warning', 'You have not permission to create or update utterance.');
  };

  renderAddNewEntityButton = () => {
    const { selected_entity } = this.state;
    const active_btn = selected_entity && selected_entity.entity && selected_entity.entity.trim().length > 0;
    const btn_text = active_btn ? `add an entity for "${selected_entity.entity}"` : 'select some part of the text to add new entity';
    return (
      <Button size="small" className={classNames("ori-font-xs ori-lr-mrgn-15 ori-border-radius-1", { "ori-btn-fill-primary-light": active_btn })} disabled={!active_btn} onClick={this.createNewEntity}>{btn_text}</Button>
    );
  };

  renderEntitySnapshot = () => {
    const { active_popup_message, nlp_details, nlpServiceName, updateEntityType, deleteEntity } = this.props;
    if (active_popup_message.NLPSnapshot && active_popup_message.NLPSnapshot.entitySnapshot) {
      if (active_popup_message.NLPSnapshot.entitySnapshot.length > 0) {
        return (
          <div className="ori-animated ori-fade-in ori-lr-pad-10 ori-t-pad-20">
            <Row className="ori-mobile-hidden ori-lr-pad-5">
              <Col xs={24} sm={8} className="ori-lr-pad-5">
                <p className="ori-font-xs ">TYPE</p>
              </Col>
              <Col xs={24} sm={16} className=" ori-lr-pad-5">
                <p className="ori-font-xs ">ENTITY</p>
              </Col>
            </Row>
            {
              active_popup_message.NLPSnapshot.entitySnapshot.map((entity, index) => {
                return (
                  <EntityEditor nlpServiceName={nlpServiceName} entities={nlp_details.entities} selected_entity={entity} key={index} index={index} updateEntityType={updateEntityType} deleteEntity={deleteEntity} />
                );
              })
            }
          </div>
        );
      } else {
        return (
          <div className="ori-animated ori-fade-in ori-lr-pad-10 ori-t-pad-20">
            <p className="ori-text-center ori-font-primary">Entity is not avaliable.</p>
          </div>
        );
      }
    } else {
      showMessage('error', 'entitySnapshot missing in NLP Snapshot.');
    }
  };

  render() {
    const { intent_extended } = this.state;
    const { nlp_details, active_popup_message, closeModal } = this.props;

    if ((active_popup_message === null) || (nlp_details.intents && nlp_details.intents.length === 0)) {
      return (
        <ShowMessage message={active_popup_message === null ? "message object not selected" : "Intent list not found. please check internet connection and refresh the page again."} sad fade_item />
      );
    } else {
      return (
        <div className="oriInsightContainer">
          <div className="ori-lr-pad-40 ori-t-pad-20 ori-b-pad-10">
            <div className="ori-relative ori-pad-10">
              <div className="ori-absolute ori-cursor-ptr ori-flex ori-pad-5 ori-border-light ori-border-radius-half alignInsightDownIcon" onClick={() => this.setState((prevState) => ({ intent_extended: !prevState.intent_extended }))}>
                <CircleDown size={16} className={classNames("ori-font-light ori-transition-half", { "ori-rotate-180": intent_extended })} />
              </div>
              <Row >
                <Col xs={24} sm={24} className="ori-pad-5" >
                  <p className="ori-font-xs">INTENT</p>
                  <Select showSearch className="ori-full-width ori-font-xs intentDropdown" size="small" defaultValue={active_popup_message.NLPSnapshot.intentSnapshot.intent} onChange={this.props.updateMessageIntent} >
                    {
                      nlp_details.intents.map(intent => {
                        return (
                          <Option key={intent.id} value={intent.name}>{intent.name} </Option>
                        );
                      })
                    }
                  </Select>
                </Col>
                <Col xs={24} sm={24} className="ori-pad-5">
                  <p className="ori-font-xs ">TEXT</p>
                  <TextEditor text={active_popup_message.payload.text} entityArray={active_popup_message && active_popup_message.NLPSnapshot && active_popup_message.NLPSnapshot.entitySnapshot ? active_popup_message.NLPSnapshot.entitySnapshot : []} handleSelectedEntityRange={this.handleSelectedEntityRange} />
                </Col>
              </Row>
            </div>
            {this.renderAddNewEntityButton()}
            {intent_extended && this.renderEntitySnapshot()}
          </div>
          <div className="ori-pad-20 ori-flex-row ori-flex-jc">
            <Button className="ori-r-mrgn-10 ori-border-radius-20" disabled={nlp_details.loaders.intents_updating} onClick={closeModal}>Cancel</Button>
            <Button type="primary" className="ori-border-radius-20" loading={nlp_details.loaders.intents_updating} onClick={this.handleSave}>Save</Button>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    nlpServiceName: state.admin_details.nlpServiceDetails ? state.admin_details.nlpServiceDetails.name : " ",
    nlp_details: state.nlp_details,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ createUtterance }, dispatch),
  };
};

Insight.propTypes = {
  nlp_details: PropTypes.object,
  nlpServiceName: PropTypes.string,
  active_popup_message: PropTypes.object,
  closeModal: PropTypes.func,
  updateMessageIntent: PropTypes.func,
  addEntity: PropTypes.func,
  updateEntityType: PropTypes.func,
  deleteEntity: PropTypes.func,
  actions: PropTypes.object,
  isActionPermitted: PropTypes.func,
  psid: PropTypes.string,
};

Insight.defaultProps = {
  nlpServiceName: " ",
};

export default connect(mapStateToProps, mapDispatchToProps)(Insight);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/chatinterface/components/insight/index.js